import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";
import EnquiryModal from "../../../models/enquiries.modal";
import { Link } from "react-router-dom";

import tutorsModal from "models/tutors.modal";
import enquiriesModal from "models/enquiries.modal";
import "../style.css";
import moment from "moment";
const DisqualifiedEnquiries = () => {
  const [modal1, setModal1] = useState(false);

  const toggleModal = () => {
    setModal1(!modal1);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal1 = () => {
    setModal2(!modal2);
  };
  const [modal3, setModal3] = useState(false);

  const toggleModal2 = () => {
    setModal3(!modal3);
  };

  const [modal4, setModal4] = useState(false);

  const toggleModal4 = () => {
    setModal4(!modal4);
  };

  const [data, setData] =useState();
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for count statistics (if needed)
    const dummyCountData = {
      count_data: {
        Disqualified: 15,
        Total: 15
      }
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyCountData);
    }, 500);
  };

  useEffect(() => {
    getListData();
  }, [location]);
  const Disqualifylist = async()=>{
    // Dummy data for disqualified enquiries
    const dummyDisqualifiedData = {
      data: [
        {
          _id: "1",
          id: "1",
          status: "disqualified_enq",
          Created_ON: "2024-01-10T08:30:00Z",
          class_type: "Separate Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Ravi",
              last_name: "Agarwal",
              username: "9876543220"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "1", name: "Sita Agarwal", class: "5" }
          ]
        },
        {
          _id: "2",
          id: "2",
          status: "disqualified_enq",
          Created_ON: "2024-01-11T12:15:00Z",
          class_type: "Combined Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Neha",
              last_name: "Joshi",
              username: "9876543221"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "2", name: "Rohan Joshi", class: "3" },
            { id: "3", name: "Isha Joshi", class: "1" }
          ]
        },
        {
          _id: "3",
          id: "3",
          status: "disqualified_enq",
          Created_ON: "2024-01-12T16:45:00Z",
          class_type: "SME",
          studentApi_parent: {
            auth_user: {
              first_name: "Manoj",
              last_name: "Tiwari",
              username: "9876543222"
            },
            modeOfTution: "Hybrid"
          },
          students: [
            { id: "4", name: "Aditya Tiwari", class: "4" }
          ]
        },
        {
          _id: "4",
          id: "4",
          status: "disqualified_enq",
          Created_ON: "2024-01-13T10:20:00Z",
          class_type: "Separate Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Kavita",
              last_name: "Bansal",
              username: "9876543223"
            },
            modeOfTution: "Online"
          },
          students: [
            { id: "5", name: "Harsh Bansal", class: "2" },
            { id: "6", name: "Priya Bansal", class: "4" }
          ]
        },
        {
          _id: "5",
          id: "5",
          status: "disqualified_enq",
          Created_ON: "2024-01-14T14:30:00Z",
          class_type: "Combined Class",
          studentApi_parent: {
            auth_user: {
              first_name: "Suresh",
              last_name: "Yadav",
              username: "9876543224"
            },
            modeOfTution: "Offline"
          },
          students: [
            { id: "7", name: "Anjali Yadav", class: "6" }
          ]
        }
      ],
      meta: {
        current_page: 1,
        per_page: 10,
        total_page: 1,
        total: 5
      }
    };
    
    setTimeout(() => {
      setData(dummyDisqualifiedData);
      setCurrentPage(dummyDisqualifiedData.meta.current_page);
      setPerPage(dummyDisqualifiedData.meta.per_page);
    }, 1000);
  }
    useEffect(()=>{
      Disqualifylist();
    },[location])
  ;

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Message", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          contact_usModel.delete(delId).then((res) => {
            helper.sweetalert.toast(res.data?.message);
            getListData();
          });
        }
      });
  };
  const [selectedClassType, setSelectedClassType] = useState("");

  const handleChangeClassType = (event) => {
    // Get the selected option
    const selectedOption = event.target.options[event.target.selectedIndex];
    // Update the state variables with the ID and name
    setSelectedClassType(selectedOption.value);
  };



  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [formattedDateTime, setFormattedDateTime] = useState('');

  const handleDateChange = (e) => {
    setDate(e.target.value);
    formatDateTime(e.target.value, time);
  };

  const handleTimeChange = (e) => {
    setTime(e.target.value);
    formatDateTime(date, e.target.value);
  };

  const formatDateTime = (date, time) => {
    if (date && time) {
      const dateTime = moment(`${date}T${time}`);
      setFormattedDateTime(dateTime.format('MM/DD/YYYY hh:mm A'));
    }
  };
const combinedatetime = `${date}T${time}`
  const [enquriId,setEnquriId] =  useState()
const [enquriStatus,setEnquriStatus] =  useState()
  const EnquriesStatusChange= (event) => {
    event.preventDefault();
    
    // Simulate changing status from disqualified to pending
    setTimeout(() => {
      setData(prevData => ({
        ...prevData,
        data: prevData.data.filter(item => item.id !== enquriId)
      }));
      helper.sweetalert.toast("Enquiry status changed to pending", "success");
      toggleModal1();
    }, 500);
  };
// firdosh code for collect disqualify list

  console.log("disqualify list",data)
  return (
    <>
      <Container className="pt-7">
      {!isLoading && (
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Disqualified Enquiry</h3>
                <div className="d-flex flex-row">
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search"
                    size="sm"
                  />
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">S.No.</th>
                    <th scope="col">Guardian Name (Mobile No)</th>
                    <th scope="col">Mode of Tuition</th>
                    <th scope="col">Status</th>
                    <th scope="col">No of Students</th>
                    <th scope="col"> Date & Time of Enquiry</th>

                    <th>Action</th>
                  </tr>
                </thead>

                {!isLoading && (
                  <tbody>
                    {data?.data.length > 0 ? (
                      data?.data?.map((item, index) => {
                        const date = new Date(item?.Created_ON);
                        
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                        const year = date.getFullYear();
                        let hours = date.getHours();
                        const minutes = String(date.getMinutes()).padStart(2, '0');
                        const ampm = hours >= 12 ? 'pm' : 'am';
                       hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight (0 hours)
                       const formattedTime = `${hours}:${minutes}${ampm}`;
                       const formatteddate = `${day}/${month}/${year}`
                       const finaldate = `${formatteddate} ${formattedTime}`
                        return (
                          <tr key={item?._id} style={{ cursor: "pointer" }}>
                            <td  id="tabledata">
                                  {index + 1}
                                </td>
                        

                    <td className="p-0 pl-3" id="tabledata">
                              {" "}
                              <Link to={`/admin/viewenquiry/${item.id}`}>
                                {item?.studentApi_parent?.auth_user?.first_name}{" "}{item?.studentApi_parent?.auth_user?.last_name}
                              </Link>
                              <span
                                style={{ marginLeft: "5px", cursor: "pointer" }}
                              >
                                {" "}
                                {item?.studentApi_parent?.auth_user?.username}
                                <span style={{ marginLeft: "3px" }}>
                                  <i class="fa-solid fa-phone"></i>
                                </span>
                              </span>
                              {/* <br />
                              <p
                                style={{
                                  backgroundColor: "red",
                                  color: "white",
                                  padding: "5px",
                                  borderRadius: "5px",
                                  fontSize: "12px",
                                  marginTop: "10px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer ",
                                  fontWeight: "bold",
                                }}
                              >
                                Requested Call Back
                              </p> */}
                            </td>

                          
                            <td>{item?.class_type|| "-"}</td>
                            {/* <td>{item?.status || "-"}</td>
                            <td>{item?.student_name || "-"}</td> */}
                               <td>
                      {" "}
                      <span
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          padding: "5px",
                          borderRadius: "5px",
                        }}
                      >
                    {item?.status || "-"}
                      </span>
                    </td>
                    <td>
                      {" "}
                      <span
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          padding: "7px",
                          borderRadius: "5px",
                        }}
                      >
                      {item?.students?.length}
                      </span>
                    </td>
                            <td>{finaldate || "-"}</td>

                            <td
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              // justifyContent: "center",
                              // alignItems: "center",
                            }}
                            className="p-0"
                            >
                              <UncontrolledTooltip
                                placement="bottom"
                                target="eyeTooltip"
                              >
                                View
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  // backgroundColor: "#f5f5f5",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="eyeTooltip"
                                to={`/admin/viewenquiry/${item?.studentApi_parent?.auth_user?.username}/${item?.id}`}
                                // tag={Link}
                              >
                                <i class="fa-solid fa-eye"></i>
                              </Link>

                              <UncontrolledTooltip
                                placement="bottom"
                                target="checkTooltip"
                              >
                                Qualified
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "green",
                                  // backgroundColor: "#f5f5f5",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                  cursor: "pointer",
                                }}
                                id="checkTooltip"
                                to={`/admin/qualifiedenquiriesViewpage/${item.id}`}
                              >
                                <i class="fa-solid fa-check"></i>
                              </Link>

                              <UncontrolledTooltip
                                placement="bottom"
                                target="clockTooltip"
                              >
                                Pending
                              </UncontrolledTooltip>
                              <p
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "orange",
                                  // backgroundColor: "#f5f5f5",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  // padding: "5px", // Optional: Add padding for better appearance
                                  borderRadius: "30%", // Optional: Make it a circle
                                }}
                                id="clockTooltip"
                                onClick={() => {toggleModal1();
                                  setEnquriId(item.id);
                                  setEnquriStatus('Pending Enquiry')
                                 }}
                               
                              >
                                <i class="fa-solid fa-clock-rotate-left"></i>
                              </p>

                              {/* <UncontrolledTooltip placement="top" target="userTooltip">
                        Disqualified
                      </UncontrolledTooltip>
                      <p style={{ margin: "0 5px" ,color:"red" }} id="userTooltip"    onClick={toggleModal2}>
                        <i class="fa-solid fa-user-xmark"></i>
                      </p> */}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="6" style={{ verticalAlign: "middle" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                    totalPages={parseInt(data?.meta?.total_page)}
                    currentPage={parseInt(data?.meta?.current_page)}
                    pageUrl="/admin/disqualifiedenquiries?"
                  />
              </CardFooter>
            </Card>
          </div>
        </Row>
      )}

        <Modal isOpen={modal1} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>
            <h4> Assign Tutors</h4>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Select Tutors</Label>
                  <Input
                    id="forType"
                    type="select"
                    // onChange={(e) => {
                    //   interViewUser(e.target.value, "board");
                    // }}
                  >
                    <option value="">select Option</option>
                    {/* {dataList &&
                      dataList?.map((item, index) => {
                        return (
                          <option value={item.mobile}>
                            {item.user?.first_name} ({item?.mobile})
                          </option>
                        );
                      })} */}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{ float: "right", marginLeft: "5%" }}
                // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal2} toggle={toggleModal1}>
          <ModalHeader toggle={toggleModal1}>
            <h4>Enquiry Pending </h4>
          </ModalHeader>
          <ModalBody>
            <Form onSubmit={EnquriesStatusChange}>
              
       
            <Input type="textarea" placeholder="Enter Reason" name="remark" />
            <Input type="date" className="mt-3" value={date} onChange={handleDateChange} />
      <Input type="time" className="mt-3" value={time} onChange={handleTimeChange} />
          
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal1}>
                Cancel
              </Button>
              {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }} // onClick={}
              >
                Save
              </Button>
            </div>
            </Form>
          </ModalBody>
        </Modal>

        <Modal isOpen={modal3} toggle={toggleModal2}>
          <ModalHeader toggle={toggleModal2}>
            <h4> Enquiry Disqualify</h4>
          </ModalHeader>
          <ModalBody>
            <Input type="textarea" placeholder="Enter Reason" />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <Button color="secondary" onClick={toggleModal2}>
                Cancel
              </Button>
              <Button
                color="primary"
                type="submit"
                style={{
                  float: "right",
                  marginLeft: "5%",
                  backgroundColor: "#080278",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }} // onClick={}
              >
                Save
              </Button>
            </div>
          </ModalBody>
        </Modal>

        
      </Container>
    </>
  );
};

export default DisqualifiedEnquiries;
